import { createContext, useContext } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const UI_VARIANTS = ['foundations', 'trellis'];
const UiVariantContext = /*#__PURE__*/createContext('foundations');
export const UiVariantProvider = ({
  variant,
  children
}) => /*#__PURE__*/_jsx(UiVariantContext.Provider, {
  value: variant,
  children: children
});
export const useUiVariant = () => useContext(UiVariantContext);